import { Grid, Card, Typography, Box } from "@mui/material";
import { Verified, LiveTv, Work, SupportAgent } from "@mui/icons-material";
import { motion, useInView } from "framer-motion";
import { useRef, useEffect } from "react";
import StudentsHiredBySection from "./StudentsHiredBySection";
import { useLocation } from "react-router-dom";

const features = [
  { title: "Certified Instructors", icon: <Verified fontSize="large" />, desc: "Learn from industry-certified experts." },
  { title: "Live Interactive Classes", icon: <LiveTv fontSize="large" />, desc: "Engage in real-time with trainers." },
  { title: "Job Assistance", icon: <Work fontSize="large" />, desc: "Get placed with our hiring partners." },
  { title: "24/7 Support", icon: <SupportAgent fontSize="large" />, desc: "Dedicated support for all your queries." }
];

const WhyChooseUs = () => {
  const ref = useRef(null);
  const trainingRef = useRef(null);
  const location = useLocation();
  const isInView = useInView(ref, { triggerOnce: false, margin: "-100px" }); // Removed `once: true`

  useEffect(() => {
    if (location.state?.scrollTo === "training-section-scroll") {
      setTimeout(() => {
        trainingRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100); // Delay helps if the DOM hasn't rendered yet
    }
  }, [location]);

  return (
    <>
      {/* "Our Students Hired By" Section */}
      <StudentsHiredBySection />

      <Box
        ref={ref}
        sx={{
          py: 8,
          background: "linear-gradient(to right, #E3F2FD, #FFFFFF)",
          color: "white",
          textAlign: "center"
        }}
      >
        <Typography variant="h4" fontWeight="bold" sx={{ mb: 3, color: "#ff6ac1" }}>
          Why Choose <span style={{ color: "#ffae42" }}>Cloud UpSkill?</span>
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Reset animation when out of view
                transition={{ duration: 0.6, delay: index * 0.2, ease: "easeOut" }}
                whileHover={{ scale: 1.05, boxShadow: "0 0 20px rgba(255, 106, 193, 0.6)" }}
              >
                <Card
                  sx={{
                    background: "linear-gradient(145deg, #0e1c36, #091726)",
                    color: "white",
                    borderRadius: 3,
                    textAlign: "center",
                    p: 3,
                    transition: "0.3s"
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "center", mb: 2, color: "#ff6ac1" }}>
                    {feature.icon}
                  </Box>
                  <Typography variant="h6" fontWeight="bold">{feature.title}</Typography>
                  <Typography variant="body2" sx={{ mt: 1, color: "#d3d3d3" }} ref={trainingRef} id="training-section-scroll" >{feature.desc}</Typography>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>

    </>
  );
};

export default WhyChooseUs;
